import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { uniq } from 'lodash';
import { saveMuscleGroups } from '../../../store/ducks/user';
import SettingsContainer from '../../../components/settings-container';
import MultiSelect from '../../../components/multi-select';

const selectOptions = [
  {
    optionText: 'Back and Chest',
    optionValue: ['back', 'chest']
  },
  {
    optionText: 'Arms and Shoulders',
    optionValue: ['arms', 'shoulders']
  },
  {
    optionText: 'Glutes',
    optionValue: ['butt']
  },
  {
    optionText: 'Legs',
    optionValue: ['legs']
  },
  {
    optionText: 'Core',
    optionValue: ['abs']
  }
];

export class MuscleGroupsPage extends Component {
  constructor(props) {
    super(props);

    this.state = { muscleGroups: props.initialValue };
  }

  save = async () => {
    try {
      await this.props.saveMuscleGroups(this.state.muscleGroups);
    } catch (e) {
      /* do nothing */
    }
  }

  getActiveOptions = () => {
    const findIndex = (muscleGroup) => {
      return selectOptions.findIndex(({ optionValue }) => optionValue.indexOf(muscleGroup) !== -1);
    };
    return uniq(this.state.muscleGroups.map(findIndex));
  }

  setMuscleGroup = (activeOptions) => {
    let muscleGroups = [];
    activeOptions.forEach((index) => {
      muscleGroups = muscleGroups.concat(selectOptions[index].optionValue);
    });

    this.setState({ muscleGroups });
  }

  render() {
    return (
      <SettingsContainer
        save={ this.save }
        className="muscle-groups-page"
        pageTitle="Select the muscle groups you’d like to focus on."
        subtitle
        isValid={ Boolean(this.state.muscleGroups.length) }
      >
        <MultiSelect
          selectOptions={ selectOptions }
          initialValue={ this.getActiveOptions() }
          setActiveOptions={ this.setMuscleGroup }
        />
      </SettingsContainer>
    );
  }
}

MuscleGroupsPage.propTypes = {
  initialValue: PropTypes.array.isRequired,
  saveMuscleGroups: PropTypes.func.isRequired
};

MuscleGroupsPage.defaultProps = {
  initialValue: []
};

export default connect(
  state => ({
    initialValue: state.user.target_areas
  }),
  dispatch => ({
    saveMuscleGroups: muscleGroups => dispatch(saveMuscleGroups(muscleGroups))
  }),
  null,
  { withRef: true }
)(MuscleGroupsPage);
